import { defineComponent as _defineComponent } from 'vue'
import jsSHA from 'jssha/dist/sha1';
import { ref, computed, onMounted } from 'vue';
import { getFromStorage, setToStorage } from '@/js/lib/helper/expirable-local-storage';


export default /*#__PURE__*/_defineComponent({
  __name: 'header-banner',
  props: {
    title: null,
    subtitle: { default: '' },
    color: null,
    backgroundColor: null,
    hidden: { type: Boolean },
    href: null,
    onCampaign: { type: Boolean },
    isSale: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as { title: string, subtitle: string, color: string, backgroundColor: string, hidden: boolean, href: string, onCampaign: boolean, isSale: boolean };


const TTL = 86400;
const styleObj = {
  '--background-color': props.backgroundColor,
  '--color': props.color,
} as Record<string, string>;
const closed = ref(false);
const key = ref('');
const visible = computed(() => props.onCampaign && !props.hidden && !closed.value);
const genKey = () => {
  const sha1 = new jsSHA('SHA-1', 'TEXT');
  sha1.update(props.href);
  key.value = `close-campaign-banner-${sha1.getHash('HEX')}`;
};
const onClick = () => {
  closed.value = true;
  setToStorage({ key: key.value, value: true, expirationSeconds: TTL });
};

onMounted(() => {
  genKey();
  closed.value = Boolean(getFromStorage({ key: key.value }));
});

return { __sfc: true,props, TTL, styleObj, closed, key, visible, genKey, onClick }
}

})